'use client';

import { createContext } from 'react';

import { Currency } from 'utils/Currency';

import type { RingProContextType } from './utils/types';

const initialRingProContextValue: RingProContextType = {
  color: null,
  setColor: () => undefined,
  size: null,
  setSize: () => undefined,
  chargerCaseColor: null,
  setChargerCaseColor: () => undefined,
  defaultCurrency: Currency.usd,
  uhx: false,
  setUhx: () => undefined,
  engraving: false,
  setEngraving: () => undefined,
  engravingMessage: null,
  setEngravingMessage: () => undefined,
  checkout: async () => undefined,
  getExpressCheckoutLineItems: () => [],
  isLoading: false,
  uhxCart: null,
  setUhxCart: () => undefined,
  afibCart: null,
  setAfibCart: () => undefined,
  cardioAdaptibilityCart: null,
  setCardioAdaptabilityCart: () => undefined,
  cnoProCart: null,
  setCnoProCart: () => undefined,
  clueCart: null,
  setClueCart: () => undefined,
  respiratoryCart: null,
  setRespiratoryCart: () => undefined,
  isLuminaryFlow: false,
  luminaryDiscount: 0,
  store: null,
  serverDiscount: { applicable: false },
  basePrice: 0,
  price: 0,
  ultraHumanPrice: 0,
  effectivePrice: 0,
  chargerPrice: 0,
  shippingEstimate: null,
  affiliateDetails: null,
  campaignActive: false,
  affiliateDiscount: 0,
  showEngravingSection: true,
  priceDrop: 0,
  effectiveDiscount: {
    type: '',
    amount: 0,
    serverAmount: 0,
    affiliateAmount: 0,
    label: undefined,
    priceTagText: undefined,
    code: undefined,
    affiliateCode: undefined,
  },
  sectionRefs: {},
  goToNextStep: () => undefined,
  notServicable: false,
  notServicableMessage: undefined,
  uhxFirstOnly: false,
  isOpenSizeDisabled: false,
  tradeInDevice: null,
  setTradeInDevice: () => undefined,
  tradeInSerialNumber: '',
  setTradeInSerialNumber: () => undefined,
  tradeInCredit: 0,
  tradeInMaxCredit: 0,
  hasUhx: false,
  tierCampaign: null,
};

export const RingProSelectionContext = createContext<RingProContextType>(
  initialRingProContextValue,
);

